import { PriceFormat } from "projects/shared/lib/components/shared/price/format/price-format.model";
import { QuantityUnitDto, ProductAvailabilityDto, ProductIdentifierDto, ShoppingCartItemDto, ShoppingCartItemValidationErrorDto } from "projects/shared/lib/services/INTEGRA_Shop_Client";
import { ENVIRONMENT } from "projects/shared/lib/environment/environment";
import { IConfigurationService } from "projects/shared/lib/services/infrastructure/configuration/configuration-service.interface";

export class CartPreviewItem {
  public productIdentifier?: ProductIdentifierDto | undefined;
  public shoppingCartItem?: ShoppingCartItemDto | undefined;
  public minimumOrderAmount: number;
  public maximumOrderAmount: number;
  public orderUnit?: QuantityUnitDto | undefined;

  public thumbnail?: string | undefined;
  public description?: string | undefined;
  public priceFormat?: PriceFormat | undefined;
  public availability?: ProductAvailabilityDto | undefined;
  public validationResult?: ShoppingCartItemValidationErrorDto | undefined;
  public availableQuantity?: number | undefined;

  constructor(configurationService: IConfigurationService, data?: CartPreviewItem | undefined) {
    this.productIdentifier = data?.productIdentifier;
    this.shoppingCartItem = data?.shoppingCartItem;
    this.priceFormat = data?.priceFormat;
    this.minimumOrderAmount = data != undefined ? data.minimumOrderAmount : 1;
    this.maximumOrderAmount = data != undefined ? data.maximumOrderAmount : ENVIRONMENT.checkout.maximumOrderAmount;
    configurationService.checkoutConfigurationGet().subscribe((checkoutConfiguration) => {
      if (checkoutConfiguration.maximumOrderAmount != undefined) {
        this.maximumOrderAmount = checkoutConfiguration.maximumOrderAmount;
      }
    });
    this.orderUnit = data?.orderUnit;

    this.thumbnail = data?.thumbnail;
    this.description = data?.description;
    this.priceFormat = data?.priceFormat;
    this.availability = data?.availability;
    this.validationResult = data?.validationResult;
    this.availableQuantity = data?.availableQuantity;
  }
}
